import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(0),
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
  },
  pointsValidityTitle: {
    display: "block",
    marginBottom: 8,
  },
  saveButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));

export const useEmailTemplateStyles = makeStyles((theme) => ({
  tagButton: {
    backgroundColor: "#e8a317",
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    fontSize: 12,
    padding: "2px 12px",
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "#c98c0f",
    },
  },
  templateBody: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: 4,
    padding: "10.5px 14px",
    minHeight: 100,
    fontFamily: "Roboto, sans-serif",
    fontSize: 16,
    lineHeight: 1.5,
    cursor: "text",
    position: "relative",
    "&:hover": {
      borderColor: "rgba(0, 0, 0, 0.87)",
    },
    "&:focus-within": {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
      padding: "9.5px 13px",
    },
  },
  templateLabel: {
    position: "absolute",
    top: -9,
    left: 10,
    backgroundColor: "#fff",
    padding: "0 4px",
    fontSize: 12,
    color: "rgba(0, 0, 0, 0.54)",
    pointerEvents: "none",
  },
  templateLabelFocused: {
    color: theme.palette.primary.main,
  },
  templateContainer: {
    position: "relative",
  },
  editableArea: {
    outline: "none",
    minHeight: 60,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    lineHeight: 1.8,
    "& .email-tag-chip": {
      display: "inline-flex",
      alignItems: "center",
      backgroundColor: "#e8a317",
      color: "#fff",
      fontWeight: 600,
      fontSize: 12,
      height: 24,
      padding: "0 8px",
      borderRadius: 12,
      margin: "0 2px",
      verticalAlign: "middle",
      userSelect: "none",
      whiteSpace: "nowrap",
    },
    "& .email-tag-chip-delete": {
      marginLeft: 4,
      cursor: "pointer",
      fontSize: 14,
      lineHeight: 1,
      color: "rgba(255,255,255,0.7)",
      "&:hover": {
        color: "#fff",
      },
    },
  },
}));

export const useLogoUploadStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  previewBox: {
    width: 250,
    height: 250,
    border: "1px solid #9e9e9e",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  placeholderIcon: {
    fontSize: 120,
    fontWeight: 300,
    fontFamily: "Roboto, Arial, sans-serif",
    color: "#c5d3de",
    lineHeight: 1,
    userSelect: "none",
  },
  placeholderText: {
    color: "#b0bec5",
    marginTop: theme.spacing(0.5),
    fontSize: 18,
    fontWeight: 300,
    fontFamily: "Roboto, Arial, sans-serif",
    letterSpacing: 0.5,
    userSelect: "none",
  },
  previewImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  logoButton: {
    width: 250,
    marginTop: theme.spacing(1),
  },
  error: {
    marginTop: theme.spacing(1),
    textAlign: "center",
  },
}));

export default useStyles;
